export enum BerthFitCheckStatus {
  Acceptable = 'A',
  NotAcceptable = 'NA',
  FurtherInfoNeeded = 'F',
}
